import React from "react";
import BarekamText from "../../../../../../components/text";
import {PaymentStatusModel} from "../../../../../../shared/models/order/payment-status.model";
import {Message, MessageSections} from "../../../../../../components/message/message";
import {BarekamSelect} from "../../../../../../components/select/select";
import {MenuItem} from "@mui/material";
import BarekamChip from "../../../../../../components/chip/barekamChip";

const PaymentStatusFilter = (props: PaymentStatusFilterProps) => {
    const {selectedFilterId, paymentStatuses, onFilterChange} = props;

    return (
        <>
            <BarekamSelect
                variant={'outlined'}
                label={<Message messageKey={'payment_status'} sectionId={MessageSections.ORDERS}/>}
                value={selectedFilterId || 'all'}
                type={"filter"}
                fullWidth
                required>
                <MenuItem onClick={() => onFilterChange(undefined)}
                                value={'all'}
                                key={'all'}>
                    <BarekamText variant={"m"}>
                        <Message messageKey={"all"} sectionId={MessageSections.ORDERS}/>
                    </BarekamText>
                </MenuItem>
                {

                    paymentStatuses.map(paymentStatus =>
                        <MenuItem onClick={() => onFilterChange(paymentStatus)}
                                        value={paymentStatus.paymentStatusId}
                                        key={paymentStatus.paymentStatusId}>
                            <BarekamChip messageKey={paymentStatus.name} statusId={paymentStatus.paymentStatusId} chipSize={"s"}/>
                        </MenuItem>
                    )
                }
            </BarekamSelect>
        </>
    );
};

export default PaymentStatusFilter;


interface PaymentStatusFilterProps {
    selectedFilterId: number | undefined;
    paymentStatuses: PaymentStatusModel[];
    onFilterChange: (filter: PaymentStatusModel | undefined) => void
}